import type { NetworkPayload } from "../../../composites";

export const API = {
  fetchTemplates: (page = 1): NetworkPayload => {
    return {
      url: `swiftwire_templates/?page=${page}`,
      options: {
        method: "GET",
      },
    };
  },

  createOrEditTemplate: (
    payload: API.CreateOrUpdateSwiftWireTemplate.Request,
    existingSwiftWireTemplateId?: API.SwiftWireTemplateId,
  ): NetworkPayload => {
    return {
      url: `swiftwire_templates/${existingSwiftWireTemplateId ? `${existingSwiftWireTemplateId}/` : ""}`,
      options: {
        method: existingSwiftWireTemplateId ? "PUT" : "POST",
        payload,
      },
    } satisfies NetworkPayload<API.CreateOrUpdateSwiftWireTemplate.Request>;
  },

  deleteTemplate: (
    swiftWireTemplateId: API.SwiftWireTemplateId,
  ): NetworkPayload => {
    return {
      url: `swiftwire_templates/${swiftWireTemplateId}/`,
      options: {
        method: "DELETE",
        isJsonResponse: false,
      },
    };
  },
};
